import log from 'salvo-lite/log'
import rivets from 'rivets'
import axios from 'axios'
import Queue from '../helpers/Queue'
import Helpers from '../helpers/Helpers'

class Cart {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = {
            cart: {}
        }
        this.renderAreas = document.querySelectorAll('[data-cart-render]')
        this.queue = new Queue()
        this.rivetsView = []
        log.debug(this.constructor.name, 'Constructed', this)
    }

    getProduct (handle, callback) {
        return axios.get(`/products/${handle}.json`).then((response) => {
            if (callback && typeof callback === 'function') {
                callback(response.data.product)
            } else {
                return response.data.product
            }
        }).catch((error) => {
            console.log(error)
        })
    }

    addItem (variantId, quantity, props, callback) {
        this.queue.enqueue(() => {
            return axios.post(this.getCartEndpoint('/cart/add.js'), {
                id: variantId,
                quantity: parseInt(quantity),
                properties: props || {}
            }).then((response) => {
                if (callback && typeof callback === 'function') {
                    callback(response.data)
                }
            }).catch((error) => {
                console.log(error)
            })
        })
    }

    updateItem (line, quantity, props, callback) {
        this.queue.enqueue(() => {
            return axios.post(this.getCartEndpoint('/cart/change.js'), {
                line: line,
                quantity: parseInt(quantity),
                properties: props || {}
            }).then((response) => {
                if (callback && typeof callback === 'function') {
                    callback(response.data)
                }
            }).catch((error) => {
                console.log(error)
            })
        })
    }

    updateQuantites (quanArr) {
        this.queue.enqueue(() => {
            return axios.post(this.getCartEndpoint('/cart/update.js'), {
                updates: quanArr
            }).then(() => {
                log.debug(this.constructor.name, 'Mass update')
            }).catch((error) => {
                console.log(error)
            })
        })
    }

    removeItem (index) {
        this.queue.enqueue(() => {
            return axios.post(this.getCartEndpoint('/cart/change.js'), {
                line: index,
                quantity: 0
            }).then(() => {
                log.debug(this.constructor.name, 'Removed item')
            }).catch((error) => {
                console.log(error)
            })
        })
    }

    getCart (callback) {
        this.queue.enqueue(() => {
            return axios.get(this.getCartEndpoint('/cart.js')).then((response) => {
                callback(response.data)
            }).catch((error) => {
                console.log(error)
            })
        })
    }

    emptyCart (callback) {
        this.queue.enqueue(() => {
            return axios.post(this.getCartEndpoint('/cart/clear.js')).then((response) => {
                callback(response.data)
            }).catch((error) => {
                console.log(error)
            })
        })
    }

    getCartEndpoint (type) {
        return `${type}?v=${(Math.floor(Math.random() * 10000000))}`
    }

    rivetsBinders () {
        rivets.formatters.getSizedImage = (src, size) => {
            return src ? Helpers.getSizedImageUrl(src, size) : ''
        }

        rivets.formatters.moneyNoSymbol = (value) => {
            return value / 100.0
        }

        rivets.formatters.money = (value) => {
            return Helpers.formatMoney(value, this._theme.shopInfo.moneyFormat)
        }

        rivets.formatters.length = (arr) => {
            return arr ? arr.length : 0
        }

        rivets.formatters.pluralize = (value, single, plural) => {
            return value === 1 ? single : plural
        }

        rivets.formatters.getItem = (arr, index) => {
            return (arr && arr.length) ? arr[parseInt(index)] : ''
        }

        rivets.formatters.getUrl = (item) => {
            return item.members ? `/products/${item.handle}` : item.url
        }

        rivets.formatters.hasVariants = (item) => {
            return item.product.variants && item.product.variants[0].title !== 'Default Title'
        }

        rivets.formatters.getOptionValue = (option, item) => {
            return item.members && item.members.length > 1 && option.values.length > 1 ? 'Mix' : option.selectedValue
        }

        rivets.binders['background'] = (el, value) => {
            el.style.setProperty('background-image', "url('" + value + "')")
        }

        rivets.formatters.quantityOptions = (quan) => {
            let max = 20
            if (quan > max) {
                max = quan + 20
            }
            return Array.from(Array(max).keys()).map((v, i) => i)
        }

        rivets.formatters.getProps = (item) => {
            let props = []
            for (let key in item.properties) {
                if (key.charAt(0) === '_') continue
                let name = key.charAt(0).toUpperCase() + key.slice(1)
                props.push({ name: name, value: item.properties[key] })
            }
            return props
        }

        rivets.formatters.not = (value) => {
            return !value
        }

        rivets.formatters.getItem = (arr, index) => {
            return (arr && arr.length) ? arr[parseInt(index)] : ''
        }
    }

    boldCartFix () {
        let i = 0
        let interval = setInterval(() => {
            if (window.BOLD && window.BOLD.common && window.BOLD.common.cartDoctor && typeof window.BOLD.common.cartDoctor.fix === 'function') {
                this._data.cart = window.BOLD.common.cartDoctor.fix(this._data.cart)
                clearInterval(interval)
            }
            if (i++ > 100) {
                clearInterval(interval)
            }
        }, 100)
    }

    async onInit () {
        log.debug(this.constructor.name, 'Initiating')

        this._data.cart = await this.prepareData(JSON.parse(this._elem.innerHTML))

        document.addEventListener('added-item', () => {
            this._data.cart.loading = true
            this.refreshCart()
            for (let area of this.renderAreas) {
                area.classList.add('shown')
            }
            document.dispatchEvent(new Event('popout-cart-shown'))
        })

        this.rivetsBinders()
        this.renderCart()

        this.boldCartFix()

        if (window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter && typeof window.BOLD.common.eventEmitter.emit === 'function') {
            window.BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', this._data.cart)
        }

        document.dispatchEvent(new Event('add-remove-tax--refresh'))

        log.debug(this.constructor.name, 'Initiated')
    }

    async prepareData (data) {
        if (window.BOLD && window.BOLD.common && window.BOLD.common.cartDoctor && typeof window.BOLD.common.cartDoctor.fix === 'function') {
            data = window.BOLD.common.cartDoctor.fix(data)
        }
        for (const [i, item] of data.items.entries()) {
            item.index = i + 1
            item.product = await this.getProduct(item.handle)
            for (let option of item.product.options) {
                option.selectedValue = item.variant_options[option.position - 1]
            }
        }

        data.loading = false

        return data
    }

    renderCart () {
        for (let cartSection of this.renderAreas) {
            rivets.bind(cartSection, this.getModel(cartSection))
        }

        this._data.cart.loading = false

        for (let cartSection of this.renderAreas) {
            this._theme.registerComponents(cartSection)
            cartSection.classList.add('rendered')
        }
    }

    getQuantityArr () {
        return this._data.cart.originalItems.map(x => x.quantity)
    }

    getVariant (selectedOptions, variants) {
        let theVariant = false
        for (let variant of variants) {
            let foundVariant = variant
            for (let [index, option] of selectedOptions.entries()) {
                if (variant[`option${index + 1}`] !== option) {
                    foundVariant = false
                }
            }
            if (foundVariant) {
                theVariant = foundVariant
                break
            }
        }
        return theVariant
    }

    getAllItems (cart) {
        return cart.items
    }

    getModel (cartSection) {
        return {
            data: this._data,
            controller: {
                updateStandardItem: (e, model) => {
                    e.preventDefault()
                    let editingItem = model.item
                    let selectedOptions = editingItem.product.options.map(x => x.selectedValue)
                    let theVariant = this.getVariant(selectedOptions, editingItem.product.variants)
                    let quantity = editingItem.quantity
                    model.data.cart.loading = true

                    if (theVariant.id !== editingItem.variant_id) {
                        // Change variant
                        this.removeItem(editingItem.index)
                        this.addItem(theVariant.id, quantity, {}, () => {
                        })
                    } else {
                        // Just change quantity
                        this.updateItem(editingItem.index, quantity, {})
                    }
                    this.refreshCart()
                },
                removeCartItem: (e, model) => {
                    e.preventDefault()
                    model.data.cart.loading = true
                    let item = model.item
                    this.removeItem(item.index)
                    this.refreshCart()
                },
                incrementQuantity: (e, model) => {
                    e.preventDefault()
                    model.data.cart.loading = true
                    var newQuantity = model.item.quantity + 1
                    this.updateItem(model.item.index, newQuantity, {})
                    this.refreshCart()
                },
                decrementQuantity: (e, model) => {
                    e.preventDefault()
                    model.data.cart.loading = true
                    var newQuantity = model.item.quantity - 1
                    this.updateItem(model.item.index, newQuantity, {})
                    this.refreshCart()
                }
            }
        }
    }

    refreshCart () {
        this.getCart(
            async (cart) => {
                this._data.cart = await this.prepareData(cart)
                document.dispatchEvent(new Event('add-remove-tax--refresh'))
                if (window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter && typeof window.BOLD.common.eventEmitter.emit === 'function') {
                    window.BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded', this._data.cart)
                }
            }
        )
    }

    removeProtocol (path) {
        return path.replace(/http(s)?:/, '')
    }
}

export default Cart



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Cart.js